(() => {
  'use-strict';

  function replaceComparateurButton(element) {
    element.classList.remove('-compare');
    element.classList.add('-view');
  }

  function initRemove(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      element.addEventListener('click', () => {
        const nid = element.dataset.compare;
        const xhr = new XMLHttpRequest();
        const url = window.location.origin.concat('/api/compare/remove/').concat(nid);
        xhr.open('GET', url);
        xhr.responseType = 'json';
        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            const response = JSON.parse(xhr.response);
            if (response.status === true) {
              window.location.href = window.drupalSettings.audencia_compare.view_url;
            }
          }
        };
        xhr.send();
      });
    });
  }

  function initAdd(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;
      // If full page, nid does not come from dataset but drupalSettings.
      const nidForFullPage = window.drupalSettings.audencia_compare.main_node;
      if (
        window.drupalSettings.audencia_compare.nid[element.dataset.compare]
        || window.drupalSettings.audencia_compare.nid[nidForFullPage]
      ) {
        replaceComparateurButton(element);
      }

      element.addEventListener('click', () => {
        let nid = element.dataset.compare;
        if (!nid) {
          nid = window.drupalSettings.audencia_compare.main_node;
        }
        if (element.classList.contains('-view')) {
          window.location.href = window.drupalSettings.audencia_compare.view_url;
        }
        // else -compare state
        const xhr = new XMLHttpRequest();
        const url = window.location.origin.concat('/api/compare/add/').concat(nid);
        xhr.open('GET', url);
        xhr.responseType = 'json';
        xhr.onload = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            const response = JSON.parse(xhr.response);
            if (response.status === true) {
              replaceComparateurButton(element);
              const counterElement = document.querySelector('.js-compare-counter');
              if (counterElement) {
                counterElement.textContent = response.num !== 0
                  ? ((response.num < 10 ? '0' : '') + response.num) : '';
              }
            }
          }
        };
        xhr.send();
      });
    });
  }

  // Function to clean null values that might appear in the DOM
  function cleanNullValues() {
    // Use TreeWalker to find all text nodes containing 'null'
    // This covers both standalone text nodes AND text inside HTML elements
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          return node.nodeValue && node.nodeValue.trim() === 'null'
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        },
      },
    );

    const nullNodes = [];
    let node;
    // eslint-disable-next-line no-cond-assign
    while (node = walker.nextNode()) {
      nullNodes.push(node);
    }

    nullNodes.forEach((nullNode) => {
      nullNode.nodeValue = '';
    });
  }

  Drupal.behaviors.compare = {
    attach: () => {
      const settingsUrl = window.drupalSettings.audencia_compare.comparator_settings_url;
      const xhr = new XMLHttpRequest();
      const url = window.location.origin.concat(settingsUrl);
      xhr.open('GET', url);
      xhr.responseType = 'json';
      xhr.onload = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
          const response = JSON.parse(xhr.response);
          window.drupalSettings.audencia_compare.view_url = response.view_url;
          window.drupalSettings.audencia_compare.nid = response.nid;
          window.drupalSettings.audencia_compare.num = response.num;
          const { num } = window.drupalSettings.audencia_compare;
          const counterElement = document.querySelector('.js-compare-counter');
          if (counterElement) {
            counterElement.textContent = num !== 0
              ? ((num < 10 ? '0' : '') + num) : '';
          }

          // Clean any null values after updating the comparator
          setTimeout(cleanNullValues, 100);

          const remove = document.querySelectorAll('.js-compare-remove');
          if (remove.length !== 0) {
            initRemove(remove);
          }
          const add = document.querySelectorAll('.js-compare-add');
          if (add.length !== 0) {
            initAdd(add);
          }
        }
      };
      xhr.send();
    },
  };

  // Also clean null values on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanNullValues);
  } else {
    cleanNullValues();
  }
})();
